export default __webpack_public_path__ + "static/media/logo_paypal.82ab19b1.png";